import React from 'react';

import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from './settings.scss';

interface Props {
  handleLogoutClick: (event: React.MouseEvent<HTMLElement>) => Promise<void>;
  handleOrganisationsClick: () => void;
  handleSettingsClick: () => void;
  hasMembersPermission: boolean;
  handleUsersClick: () => void;
}

export const SettingsList = ({
  hasMembersPermission,
  handleUsersClick,
  handleOrganisationsClick,
  handleLogoutClick,
  handleSettingsClick
}: Props) => (
  <div>
    <button type="button" className={styles.title} onClick={handleSettingsClick}>
      <Typography fontWeight="500" fontSize="14px" inverse m={0}>
        <FormattedMessage id="common.settings" defaultMessage="Settings" />
      </Typography>
    </button>
    <div className={styles.option} onClick={handleOrganisationsClick}>
      <FormattedMessage id="common.organisations" defaultMessage="Organisations" />
    </div>
    {hasMembersPermission && (
      <div className={styles.option} onClick={handleUsersClick}>
        <FormattedMessage id="common.users" defaultMessage="Users" />
      </div>
    )}
    <div className={styles.option} onClick={handleLogoutClick}>
      <FormattedMessage id="common.log_out" defaultMessage="Log out" />
    </div>
    <div className={styles.divider} />
  </div>
);
